import { getPrivateApi } from "../lib/axiosConfig";
import { Customer, EditCustomer, NewCustomer } from "../types/customers.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/clients"

export const getCustomers = async (): Promise<Customer[]> => {

  try {
    const { data: customerList } = await api.get(`${endpoint}`)

    return customerList;
  } catch (error: any) {
    const errMsg = "Erro ao buscar clientes";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const addCustomer = async (newCustomer: NewCustomer): Promise<Customer> => {
  const { name, document, balance } = newCustomer;

  try {
    const { data: newCustomer } = await api.post(`${endpoint}`,
      {
        name,
        document,
        balance
      }
    );

    return newCustomer
  } catch (error: any) {
    const errMsg = "Erro ao criar cliente";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const editCustomer = async (customer: EditCustomer): Promise<Customer> => {
  const { name, document, balance, id } = customer;

  try {
    const { data: editedCustomer } = await api.put(`${endpoint}/${id}`, {
      name,
      document,
      balance,
    });

    return editedCustomer;
  } catch (error: any) {
    const errMsg = "Erro ao editar cliente";
    
    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}

export const deleteCustomer = async (customerId: string): Promise<void> => {
  try {
    await api.delete(`${endpoint}/${customerId}`);
  } catch (error: any) {
    const errMsg = "Erro ao deletar cliente";
    
    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new AppError(message, error.status);
  };
}
